/**
 * Created by razial on 28.10.2021
 */

const ExpeditionPassRulesOptions = {
    name: "ExpeditionPassRulesWindow",

    getGuideBundle: function () {
        return bundles[`${cleverapps.skins.getSlot("skinName")}_expeditionguidewindow`];
    },

    stagesContent: function () {
        const styles = cleverapps.styles.ExpeditionPassRulesWindow;
        const unitCode = cleverapps.unitsLibrary.listCodesByType(cleverapps.unitsLibrary.getExpeditionUnitType("resource"))[0];

        const stage1 = this.initStage(styles.firstStage, (styles, container) => {
            const ground = this.addSprite(container, this.bundle.frames.expedition_ground, styles.ground);

            [this.bundle.frames.highlight_dark, this.bundle.frames.highlight_light, this.bundle.frames.highlight_light].map(function (image, index) {
                return this.addSprite(ground, image, styles.highlight[index]);
            }, this);
            [{ code: unitCode, stage: 0 }, { code: unitCode, stage: 0 }, { code: unitCode, stage: 0 }].forEach(function (unit, index) {
                this.addUnitIcon(ground, unit.code, unit.stage, styles.units[index]);
            }, this);
        });

        const stage2 = this.initStage(styles.secondStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.expedition_grave, styles.ground);

            const star = new cleverapps.Spine(bundles.merge.jsons.buildpass_point);
            star.setScale(styles.star.scale || 1.0);
            star.setAnchorPoint(0.5, 0.5);
            star.setAlignment(styles.star);
            star.setAnimation(0, "idle", true);
            container.addChild(star);

            star.runAction(new cc.Sequence(
                new cc.DelayTime(0.1),
                new cc.CallFunc(star.clearTrack.bind(star, 0))
            ));

            if (unitCode) {
                this.addUnitIcon(container, unitCode, 1, styles.unit);
            }
            this.addSprite(star, bundles.guidewindow_arrows.frames.tutorial_hand_png, styles.finger);
        });

        const stage3 = this.initStage(styles.thirdStage, (styles, container) => {
            this.addSprite(container, this.bundle.frames.yellow_light, styles.light);
            if (cleverapps.config.name === "mergecraft") {
                this.addSprite(container, this.bundle.frames.expedition_ground, styles.ground);
            }
            this.addSprite(container, this.bundle.frames.prizes_heap, styles.prizes);
        });

        return [stage1, stage2, stage3];
    }
};

cleverapps.styles.ExpeditionPassRulesWindow = {
    firstStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: -40 }
        },

        ground: {
            x: 0,
            y: 0
        },

        highlight: [{
            x: 192,
            y: 182
        }, {
            x: 104,
            y: 133
        }, {
            x: 278,
            y: 133
        }],

        units: [{
            x: 197,
            y: 193
        }, {
            x: 108,
            y: 144
        }, {
            x: 284,
            y: 143
        }]
    },

    secondStage: {
        container: {
            x: { align: "center" },
            y: { align: "center" }
        },

        ground: {
            x: -10,
            y: -120
        },

        light: {
            x: 0,
            y: -70
        },

        unit: {
            x: -14,
            y: -103,
            scale: 1.2
        },

        star: {
            x: -15,
            y: 75,
            scale: 1.5
        },

        finger: {
            x: 160,
            y: -50
        }
    },

    thirdStage: {
        container: {
            x: { align: "center" },
            y: { align: "center", dy: 20 }
        },

        light: {
            x: 0,
            y: 0
        },

        ground: {
            x: 0,
            y: -50
        },

        prizes: {
            x: 0,
            y: 0
        }
    }
};
